/**
 * Bracket Highlight — Horizon Pro
 * Scans text nodes for [bracketed words] and wraps them in
 * <span class="hp-highlight"> for global styling via CSS variables.
 * Respects prefers-reduced-motion for animated highlight styles.
 */

(function () {
  'use strict';

  const BRACKET_RE = /\[([^\]]+)\]/g;
  const SCAN_SELECTOR = '.text-block, .rte, h1, h2, h3, h4, h5, h6, p, .banner__text, .rich-text__text';
  const SKIP_TAGS = new Set(['CODE', 'PRE', 'SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT']);

  const processed = new WeakSet();

  function shouldSkip(node) {
    let el = node.parentElement;
    while (el) {
      if (SKIP_TAGS.has(el.tagName)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function processTextNode(textNode) {
    if (!BRACKET_RE.test(textNode.nodeValue)) return;
    if (shouldSkip(textNode)) return;

    const frag = document.createDocumentFragment();
    let lastIndex = 0;
    const text = textNode.nodeValue;

    BRACKET_RE.lastIndex = 0;
    let match;
    while ((match = BRACKET_RE.exec(text)) !== null) {
      // Text before the match
      if (match.index > lastIndex) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      }
      // The highlighted span
      const span = document.createElement('span');
      span.className = 'hp-highlight';
      span.textContent = match[1];
      frag.appendChild(span);
      lastIndex = BRACKET_RE.lastIndex;
    }

    // Remaining text
    if (lastIndex < text.length) {
      frag.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    textNode.parentNode.replaceChild(frag, textNode);
  }

  function scanElement(el) {
    if (processed.has(el)) return;
    processed.add(el);

    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) {
      if (BRACKET_RE.test(node.nodeValue)) {
        textNodes.push(node);
      }
    }
    // Process in reverse so replacements don't invalidate the walker
    for (let i = textNodes.length - 1; i >= 0; i--) {
      processTextNode(textNodes[i]);
    }
  }

  function scanAll(root) {
    root.querySelectorAll(SCAN_SELECTOR).forEach(scanElement);
  }

  // Initial scan
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scanAll(document));
  } else {
    scanAll(document);
  }

  // Watch for dynamically added content (section re-renders, AJAX)
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(SCAN_SELECTOR)) {
          scanElement(node);
        }
        if (node.querySelectorAll) {
          scanAll(node);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
